




export function createBackBtn (clickEvent:Function) : HTMLButtonElement {
    const backBtn : HTMLButtonElement = document.createElement('button');
    backBtn.innerHTML = 'Terug';
    backBtn.classList.add('back-btn');

    backBtn.addEventListener('click', evt => clickEvent(evt));

    return backBtn;
}





export default function setupBackBtn () {
    window.addEventListener('DOMContentLoaded', () => {
        const breadcrumbs : HTMLElement | null = document.querySelector('.breadcrumbs');

        if ( breadcrumbs ) {
            breadcrumbs.prepend(createBackBtn(() => window.history.back()));
        }
    });
}
